import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "./i18n/LanguageContext";
import LandingPage from "./pages/LandingPage";
import ProgramsPage from "./pages/ProgramsPage";
import PortalLoginPage from "./pages/PortalLoginPage";
import RegisterPage from "./pages/RegisterPage";
import AdminPage from "./pages/AdminPage";
import PlayerProfilePage from "./pages/PlayerProfilePage";
import CalendarPage from "./pages/CalendarPage";
import ParentPortalPage from "./pages/ParentPortalPage";
import AdminPaymentsPage from "./pages/AdminPaymentsPage";
import SampleProfilePage from "./pages/SampleProfilePage";
import AdminDemoPage from "./pages/AdminDemoPage";
import SoccerTroopElitePage from "./pages/SoccerTroopElitePage";
import AdminElitePage from "./pages/AdminElitePage";
import "./App.css";

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/programs" element={<ProgramsPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/portal" element={<PortalLoginPage />} />
          <Route path="/demo" element={<SampleProfilePage />} />
          <Route path="/elite" element={<SoccerTroopElitePage />} />
          <Route path="/p/:token" element={<ParentPortalPage />} />
          <Route path="/admin" element={<AdminPage />} />
          <Route path="/admin/player/:id" element={<PlayerProfilePage />} />
          <Route path="/admin/calendar" element={<CalendarPage />} />
          <Route path="/admin/payments" element={<AdminPaymentsPage />} />
          <Route path="/admin/demo" element={<AdminDemoPage />} />
          <Route path="/admin/elite" element={<AdminElitePage />} />
        </Routes>
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
